import { travelGuideQueryKeys as e } from "./travelGuideQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { travelGuidesApi as n } from "@maat/api-main";
//#region src/travelGuides/useTravelGuideQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.get(r),
	enabled: !!r
});
//#endregion
export { r as useTravelGuideQuery };
